import { Separator } from '@heroui/react';
import { oauthProviders } from '@rhino-project/core/utils';
import { OmniAuthButton } from './omniauth';

/**
 * Renders the configured OAuth providers as a full-width column of buttons,
 * preceded by a separator. Renders nothing when no providers are configured.
 * Shared by the sign-in and sign-up pages so their OAuth section stays
 * consistent.
 */
export const OmniAuthButtonGroup = () => {
  const providers = oauthProviders() as { name: string; path: string }[];

  if (providers.length === 0) return null;

  return (
    <>
      <Separator className="my-4" />
      <div className="flex flex-col gap-2">
        {providers.map((p) => (
          <OmniAuthButton
            key={p.name}
            provider={p.name}
            providerPath={p.path}
          />
        ))}
      </div>
    </>
  );
};
